import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Outcome() {
  return (
    <section className="goals-serve-easy case-about-sec case-about-left case-about-overlay">
      <Container>
        <Row className="align-items-center justify-content-between flex-md-row flex-column-reverse">
            <Col
                xs={12}
                md={6}
                lg={5}
                xl={5}
                xxl={6}
                className=""
            >
                <div className="image text-md-start text-center">
                <StaticImage
                    src="../../../images/case-studies/serve-easy/outcome.webp"
                    alt="The Challenge"
                    className=""
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={729}
                    height={854}
                />
                </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-md-0 mb-4">
            <div class="content text_white">
              <h2>
              The Outcome
              </h2>
              <p>ServeEasy has achieved over 50 successful deployments, delivering a 30% improvement in order processing speed and a 25% reduction in transaction times. Clients report enhanced customer satisfaction and streamlined operations, with significant reductions in order errors and payment processing issues.</p>
            </div>
          </Col>
         
          
        </Row>
      </Container>
    </section>
  );
}

export default Outcome;
